import "./style.css";
import layout from "./layout.html";

export default class MaisonImages {
  static selector = ".maison__images";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
